export enum SettingsFields {
  firstName = 'firstName',
  lastName = 'lastName',
  email = 'email',
  phoneNumber = 'phoneNumber',
  companyRole = 'companyRole'
}
